import { render } from "./MainSurvey.vue?vue&type=template&id=3d055fb1"
import script from "./MainSurvey.vue?vue&type=script&lang=js"
export * from "./MainSurvey.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__